import type { MouseEvent } from 'react'

import type { CreativeLibraryItem } from '../../demo/types'
import { Button, CreativeCard } from '../../ui'
import { creativeCopy } from './copy'
import styles from './CreativesPage.module.css'

export interface CreativeGridProps {
  creatives: CreativeLibraryItem[]
  onPreview: (creative: CreativeLibraryItem) => void
  onUse: (creative: CreativeLibraryItem) => void
}

function stop(event: MouseEvent<HTMLButtonElement>) {
  event.stopPropagation()
}

export function CreativeGrid({ creatives, onPreview, onUse }: CreativeGridProps) {
  const sorted = [...creatives].sort((left, right) => right.createdAt.localeCompare(left.createdAt) || right.id.localeCompare(left.id))
  return (
    <div className={styles.grid} data-scope="creatives-grid">
      {sorted.map((creative) => (
        <CreativeCard
          key={creative.id}
          data-creative-id={creative.id}
          name={creative.name}
          kind={creative.kind}
          cover={creative.cover}
          dataUrl={creative.dataUrl}
          duration={creative.duration}
          source={creative.source}
          kol={creative.kol}
          usedByAds={creative.usedByAds}
          compliance={creative.compliance}
          showUsage
          onClick={() => onPreview(creative)}
          actions={(
            <>
              <Button size="pill-sm" onClick={(event) => { stop(event); onPreview(creative) }}>{creativeCopy.preview}</Button>
              <Button size="pill-sm" variant="secondary" onClick={(event) => { stop(event); onUse(creative) }}>{creativeCopy.useForAd}</Button>
            </>
          )}
        />
      ))}
    </div>
  )
}
